(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/racing-game/components/play/assets/javascripts/coupon/coupon-context.js') >= 0) return;  svs.modules.push('/modules/racing-game/components/play/assets/javascripts/coupon/coupon-context.js');
"use strict";


const {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState
} = React;
const PlayContext = svs.racing_game.components.playContext.PlayContext;
const CouponContext = createContext();
const CouponContextProvider = _ref => {
  let {
    children
  } = _ref;
  const {
    engine
  } = useContext(PlayContext);
  const getDefaultEngineStake = useCallback(() => engine.stake.amounts[engine.stake.amountsDefaultIndex], [engine]);
  const getDefaultSelectedAmount = useCallback(() => svs.components.Storage.browser.get("defaultSelectedAmount-".concat(engine.gameType), 'Racing') || getDefaultEngineStake(), [engine.gameType, getDefaultEngineStake]);
  const setDefaultSelectedAmount = useCallback(amount => {
    svs.components.Storage.browser.set("defaultSelectedAmount-".concat(engine.gameType), 'Racing', amount, svs.components.Storage.constants.EXPIRES_24H);
  }, [engine.gameType]);
  const [selectedAmount, setSelectedAmount] = useState(getDefaultSelectedAmount);
  const setSelectedAndDefaultAmount = useCallback(amount => {
    if (!amount) {
      amount = getDefaultEngineStake();
    }
    setSelectedAmount(amount);
    setDefaultSelectedAmount(amount);
  }, [setSelectedAmount, setDefaultSelectedAmount, getDefaultEngineStake]);
  useEffect(() => {
    setSelectedAmount(getDefaultSelectedAmount());
  }, [engine.gameType]);
  return React.createElement(CouponContext.Provider, {
    value: {
      selectedAmount,
      setSelectedAmount: setSelectedAndDefaultAmount
    }
  }, children);
};
svs.racing_game.components.playContext.CouponContext = CouponContext;
svs.racing_game.components.playContext.CouponContextProvider = CouponContextProvider;

 })(window);